import dayjs from 'dayjs'
import { t } from 'i18next'

const locales = {
  de: () => import('dayjs/locale/de'),
  en: () => import('dayjs/locale/en'),
}

export const SetupDateLocale = (): void => {
  locales[t<string>('locales.dayjs_locale')]().then(() =>
    dayjs.locale(t<string>('locales.dayjs_locale'))
  )
}